import React from 'react';

const Cancel = () => {
  return (
    <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Ecran-3---1-V2" transform="translate(-16.000000, -105.000000)">
          <g id="icon/(+)-copy" transform="translate(17.000000, 106.000000)">
            <g id="(+)">
              <circle
                id="Oval"
                stroke="#E74248"
                cx="8.5"
                cy="8.5"
                r="8.5"
              ></circle>
              <g
                id="+"
                transform="translate(8.500000, 8.500000) rotate(-45.000000) translate(-8.500000, -8.500000) translate(4.636364, 4.636364)"
                fill="#E74248"
                fillRule="nonzero"
              >
                <path
                  d="M3.09090909,0.066969697 C3.09090909,-0.359795792 3.43687088,-0.705757576 3.86363636,-0.705757576 C4.29040185,-0.705757576 4.63636364,-0.359795792 4.63636364,0.066969697 L4.63636364,7.46969697 C4.63636364,7.89646246 4.29040185,8.24242424 3.86363636,8.24242424 C3.43687088,8.24242424 3.09090909,7.89646246 3.09090909,7.46969697 L3.09090909,0.066969697 Z"
                  id="Line-5"
                ></path>
                <path
                  d="M3.09090909,0.066969697 C3.09090909,-0.359795792 3.43687088,-0.705757576 3.86363636,-0.705757576 C4.29040185,-0.705757576 4.63636364,-0.359795792 4.63636364,0.066969697 L4.63636364,7.46969697 C4.63636364,7.89646246 4.29040185,8.24242424 3.86363636,8.24242424 C3.43687088,8.24242424 3.09090909,7.89646246 3.09090909,7.46969697 L3.09090909,0.066969697 Z"
                  id="Line-5"
                  transform="translate(3.863636, 3.768333) rotate(-270.000000) translate(-3.863636, -3.768333) "
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Cancel;
